import React from 'react';
import { I18n } from 'aws-amplify';

// 英語の表記とデータの表記が異なるのでひもづけるリストを定義
import { ASSET_LIST } from '../../../configures/val.js';

function TasteSelector(props) {
  // もし this.selectedAssetId と asset が一致していたら selected にする
  let options = null;
  if (props.assetId !== 'customized_screen') {
    options = ASSET_LIST.map((asset) =>
      <option key={asset.id} value={asset.id}>
        {I18n.get(asset.name)}
      </option>
    );
  }
  return (
    <div id="mierukaAssetSelector">
      <select name="assetSelector" onChange={(e) => props.changeTaste(e)} value={props.assetId} disabled={props.isDisabled}>
        {options ? options : <option key='customized_screen' value='customized_screen'>{I18n.get('Customized screen')}</option>}
      </select>
    </div>
  );
}

export default TasteSelector;

